import { inject } from 'mobx-react'
import React from 'react'
import ContentWrapper from '../Layout/ContentWrapper'
import OrderForm from './components/OrderForm'

@inject('userStore')
class EditOrder extends React.Component {
  constructor(props) {
    super(props)
    if (props.userStore.user_id) {
      this.state = {
        user: {
          user_id: props?.userStore.user_id,
          userLevel: props?.userStore.userLevel
        }
      }
    }
  }

  render() {
    return <ContentWrapper>{this.state.user && <OrderForm user={this.state.user} type='edit' />}</ContentWrapper>
  }
}

export default EditOrder
